"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CouponTemplateServiceServer = exports.CouponTemplateServiceDispatcher = exports.CouponTemplateServiceClient = void 0;
var CouponsTemplateResponse_1 = require("./CouponsTemplateResponse");
var octopus_common_1 = require("@playq/octopus-common");
var services_shared_1 = require("@playq/services-shared");
var services_bookkeeper_1 = require("@playq/services-bookkeeper");
var CouponTemplateGetResponse_1 = require("./CouponTemplateGetResponse");
var CouponsSort_1 = require("./CouponsSort");
var octopus_notifications_1 = require("@playq/octopus-notifications");
var irt_1 = require("@playq/irt");
var InCreate = (function () {
    function InCreate(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.app = new octopus_common_1.AppID(data.app);
        this.content = services_bookkeeper_1.CouponTemplateDataStruct.create(data.content);
    }
    Object.defineProperty(InCreate.prototype, "app", {
        get: function () {
            return this._app;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field app is not optional');
            }
            this._app = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InCreate.prototype, "content", {
        get: function () {
            return this._content;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field content is not optional');
            }
            this._content = value;
        },
        enumerable: false,
        configurable: true
    });
    InCreate.prototype.serialize = function () {
        var _a;
        return {
            app: this.app.serialize(),
            content: (_a = {}, _a[this.content.getFullClassName()] = this.content.serialize(), _a)
        };
    };
    return InCreate;
}());
var OutCreateHelpers = (function () {
    function OutCreateHelpers() {
    }
    OutCreateHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutCreateHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_bookkeeper_1.CouponTemplateID(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutCreateHelpers;
}());
var InUpdate = (function () {
    function InUpdate(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.coupon = new services_bookkeeper_1.CouponTemplate(data.coupon);
    }
    Object.defineProperty(InUpdate.prototype, "coupon", {
        get: function () {
            return this._coupon;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field coupon is not optional');
            }
            this._coupon = value;
        },
        enumerable: false,
        configurable: true
    });
    InUpdate.prototype.serialize = function () {
        return {
            coupon: this.coupon.serialize()
        };
    };
    return InUpdate;
}());
var OutUpdateHelpers = (function () {
    function OutUpdateHelpers() {
    }
    OutUpdateHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutUpdateHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutUpdateHelpers;
}());
var InDelete = (function () {
    function InDelete(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new services_bookkeeper_1.CouponTemplateID(data.id);
    }
    Object.defineProperty(InDelete.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    InDelete.prototype.serialize = function () {
        return {
            id: this.id.serialize()
        };
    };
    return InDelete;
}());
var OutDeleteHelpers = (function () {
    function OutDeleteHelpers() {
    }
    OutDeleteHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutDeleteHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutDeleteHelpers;
}());
var InPromote = (function () {
    function InPromote(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new services_bookkeeper_1.CouponTemplateID(data.id);
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InPromote.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InPromote.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InPromote.prototype.serialize = function () {
        return {
            id: this.id.serialize(),
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InPromote;
}());
var OutPromoteHelpers = (function () {
    function OutPromoteHelpers() {
    }
    OutPromoteHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutPromoteHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutPromoteHelpers;
}());
var InDemote = (function () {
    function InDemote(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new services_bookkeeper_1.CouponTemplateID(data.id);
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InDemote.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InDemote.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InDemote.prototype.serialize = function () {
        return {
            id: this.id.serialize(),
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InDemote;
}());
var OutDemoteHelpers = (function () {
    function OutDemoteHelpers() {
    }
    OutDemoteHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutDemoteHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutDemoteHelpers;
}());
var InGet = (function () {
    function InGet(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new services_bookkeeper_1.CouponTemplateID(data.id);
    }
    Object.defineProperty(InGet.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    InGet.prototype.serialize = function () {
        return {
            id: this.id.serialize()
        };
    };
    return InGet;
}());
var OutGetHelpers = (function () {
    function OutGetHelpers() {
    }
    OutGetHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutGetHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new CouponTemplateGetResponse_1.CouponTemplateGetResponse(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutGetHelpers;
}());
var InQueryCoupons = (function () {
    function InQueryCoupons(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.app = new octopus_common_1.AppID(data.app);
        this.iterator = new services_shared_1.OffsetLimit(data.iterator);
        this.sortBy = data.sortBy.map(function (e) { return new CouponsSort_1.CouponsSort(e); });
        this.filterBy = Object.keys(data.filterBy).reduce(function (previous, current) { previous[current] = octopus_common_1.FilterHelpers.deserialize(data.filterBy[current]); return previous; }, {});
    }
    Object.defineProperty(InQueryCoupons.prototype, "app", {
        get: function () {
            return this._app;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field app is not optional');
            }
            this._app = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryCoupons.prototype, "iterator", {
        get: function () {
            return this._iterator;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field iterator is not optional');
            }
            this._iterator = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryCoupons.prototype, "sortBy", {
        get: function () {
            return this._sortBy;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field sortBy is not optional');
            }
            this._sortBy = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryCoupons.prototype, "filterBy", {
        get: function () {
            return this._filterBy;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field filterBy is not optional');
            }
            this._filterBy = value;
        },
        enumerable: false,
        configurable: true
    });
    InQueryCoupons.prototype.serialize = function () {
        var _this = this;
        return {
            app: this.app.serialize(),
            iterator: this.iterator.serialize(),
            sortBy: this.sortBy.map(function (e) { return e.serialize(); }),
            filterBy: Object.keys(this.filterBy).reduce(function (previous, current) { previous[current] = octopus_common_1.FilterHelpers.serialize(_this.filterBy[current]); return previous; }, {})
        };
    };
    return InQueryCoupons;
}());
var OutQueryCouponsHelpers = (function () {
    function OutQueryCouponsHelpers() {
    }
    OutQueryCouponsHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutQueryCouponsHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new CouponsTemplateResponse_1.CouponsTemplateResponse(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutQueryCouponsHelpers;
}());
var InQueryNotifications = (function () {
    function InQueryNotifications(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.appID = new octopus_common_1.AppID(data.appID);
        this.couponTemplate = typeof data.couponTemplate !== 'undefined' ? new services_bookkeeper_1.CouponTemplateID(data.couponTemplate) : undefined;
        this.iterator = new services_shared_1.OffsetLimit(data.iterator);
        this.sortBy = data.sortBy.map(function (e) { return new octopus_notifications_1.NotificationsSort(e); });
        this.filterBy = Object.keys(data.filterBy).reduce(function (previous, current) { previous[current] = octopus_common_1.FilterHelpers.deserialize(data.filterBy[current]); return previous; }, {});
    }
    Object.defineProperty(InQueryNotifications.prototype, "appID", {
        get: function () {
            return this._appID;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field appID is not optional');
            }
            this._appID = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryNotifications.prototype, "couponTemplate", {
        get: function () {
            return this._couponTemplate;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._couponTemplate = undefined;
                return;
            }
            this._couponTemplate = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryNotifications.prototype, "iterator", {
        get: function () {
            return this._iterator;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field iterator is not optional');
            }
            this._iterator = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryNotifications.prototype, "sortBy", {
        get: function () {
            return this._sortBy;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field sortBy is not optional');
            }
            this._sortBy = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryNotifications.prototype, "filterBy", {
        get: function () {
            return this._filterBy;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field filterBy is not optional');
            }
            this._filterBy = value;
        },
        enumerable: false,
        configurable: true
    });
    InQueryNotifications.prototype.serialize = function () {
        var _this = this;
        return {
            appID: this.appID.serialize(),
            couponTemplate: typeof this.couponTemplate !== 'undefined' ? this.couponTemplate.serialize() : undefined,
            iterator: this.iterator.serialize(),
            sortBy: this.sortBy.map(function (e) { return e.serialize(); }),
            filterBy: Object.keys(this.filterBy).reduce(function (previous, current) { previous[current] = octopus_common_1.FilterHelpers.serialize(_this.filterBy[current]); return previous; }, {})
        };
    };
    return InQueryNotifications;
}());
var OutQueryNotificationsHelpers = (function () {
    function OutQueryNotificationsHelpers() {
    }
    OutQueryNotificationsHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutQueryNotificationsHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new octopus_notifications_1.NotificationsResponse(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutQueryNotificationsHelpers;
}());
var InGetAnnotations = (function () {
    function InGetAnnotations(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.appID = new octopus_common_1.AppID(data.appID);
        this.couponTemplate = new services_bookkeeper_1.CouponTemplateID(data.couponTemplate);
    }
    Object.defineProperty(InGetAnnotations.prototype, "appID", {
        get: function () {
            return this._appID;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field appID is not optional');
            }
            this._appID = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InGetAnnotations.prototype, "couponTemplate", {
        get: function () {
            return this._couponTemplate;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field couponTemplate is not optional');
            }
            this._couponTemplate = value;
        },
        enumerable: false,
        configurable: true
    });
    InGetAnnotations.prototype.serialize = function () {
        return {
            appID: this.appID.serialize(),
            couponTemplate: this.couponTemplate.serialize()
        };
    };
    return InGetAnnotations;
}());
var OutGetAnnotationsHelpers = (function () {
    function OutGetAnnotationsHelpers() {
    }
    OutGetAnnotationsHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutGetAnnotationsHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new octopus_notifications_1.UserAnnotations(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutGetAnnotationsHelpers;
}());
var InAddAnnotation = (function () {
    function InAddAnnotation(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.appID = new octopus_common_1.AppID(data.appID);
        this.couponTemplate = new services_bookkeeper_1.CouponTemplateID(data.couponTemplate);
        this.text = data.text;
    }
    Object.defineProperty(InAddAnnotation.prototype, "appID", {
        get: function () {
            return this._appID;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field appID is not optional');
            }
            this._appID = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InAddAnnotation.prototype, "couponTemplate", {
        get: function () {
            return this._couponTemplate;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field couponTemplate is not optional');
            }
            this._couponTemplate = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InAddAnnotation.prototype, "text", {
        get: function () {
            return this._text;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field text is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field text expects type string, got ' + value);
            }
            this._text = value;
        },
        enumerable: false,
        configurable: true
    });
    InAddAnnotation.prototype.serialize = function () {
        return {
            appID: this.appID.serialize(),
            couponTemplate: this.couponTemplate.serialize(),
            text: this.text
        };
    };
    return InAddAnnotation;
}());
var OutAddAnnotationHelpers = (function () {
    function OutAddAnnotationHelpers() {
    }
    OutAddAnnotationHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutAddAnnotationHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutAddAnnotationHelpers;
}());
var CouponTemplateServiceClient = (function () {
    function CouponTemplateServiceClient(transport) {
        this._transport = transport;
    }
    CouponTemplateServiceClient.prototype.getPackageName = function () { return CouponTemplateServiceClient.PackageName; };
    CouponTemplateServiceClient.prototype.getClassName = function () { return CouponTemplateServiceClient.ClassName; };
    CouponTemplateServiceClient.prototype.getFullClassName = function () { return CouponTemplateServiceClient.FullClassName; };
    CouponTemplateServiceClient.prototype.send = function (method, data, inputType, outputType) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._transport.send(CouponTemplateServiceClient.ClassName, method, data)
                .then(function (data) {
                try {
                    var output = new outputType(data);
                    resolve(output);
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    CouponTemplateServiceClient.prototype.create = function (app, content) {
        var _this = this;
        var __data = new InCreate();
        __data.app = app;
        __data.content = content;
        return new Promise(function (resolve, reject) {
            _this._transport.send(CouponTemplateServiceClient.ClassName, 'create', __data)
                .then(function (data) {
                try {
                    resolve(OutCreateHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    CouponTemplateServiceClient.prototype.update = function (coupon) {
        var _this = this;
        var __data = new InUpdate();
        __data.coupon = coupon;
        return new Promise(function (resolve, reject) {
            _this._transport.send(CouponTemplateServiceClient.ClassName, 'update', __data)
                .then(function (data) {
                try {
                    resolve(OutUpdateHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    CouponTemplateServiceClient.prototype.delete = function (id) {
        var _this = this;
        var __data = new InDelete();
        __data.id = id;
        return new Promise(function (resolve, reject) {
            _this._transport.send(CouponTemplateServiceClient.ClassName, 'delete', __data)
                .then(function (data) {
                try {
                    resolve(OutDeleteHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    CouponTemplateServiceClient.prototype.promote = function (id, env) {
        var _this = this;
        var __data = new InPromote();
        __data.id = id;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(CouponTemplateServiceClient.ClassName, 'promote', __data)
                .then(function (data) {
                try {
                    resolve(OutPromoteHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    CouponTemplateServiceClient.prototype.demote = function (id, env) {
        var _this = this;
        var __data = new InDemote();
        __data.id = id;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(CouponTemplateServiceClient.ClassName, 'demote', __data)
                .then(function (data) {
                try {
                    resolve(OutDemoteHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    CouponTemplateServiceClient.prototype.get = function (id) {
        var _this = this;
        var __data = new InGet();
        __data.id = id;
        return new Promise(function (resolve, reject) {
            _this._transport.send(CouponTemplateServiceClient.ClassName, 'get', __data)
                .then(function (data) {
                try {
                    resolve(OutGetHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    CouponTemplateServiceClient.prototype.queryCoupons = function (app, iterator, sortBy, filterBy) {
        var _this = this;
        var __data = new InQueryCoupons();
        __data.app = app;
        __data.iterator = iterator;
        __data.sortBy = sortBy;
        __data.filterBy = filterBy;
        return new Promise(function (resolve, reject) {
            _this._transport.send(CouponTemplateServiceClient.ClassName, 'queryCoupons', __data)
                .then(function (data) {
                try {
                    resolve(OutQueryCouponsHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    CouponTemplateServiceClient.prototype.queryNotifications = function (appID, couponTemplate, iterator, sortBy, filterBy) {
        var _this = this;
        var __data = new InQueryNotifications();
        __data.appID = appID;
        __data.couponTemplate = couponTemplate;
        __data.iterator = iterator;
        __data.sortBy = sortBy;
        __data.filterBy = filterBy;
        return new Promise(function (resolve, reject) {
            _this._transport.send(CouponTemplateServiceClient.ClassName, 'queryNotifications', __data)
                .then(function (data) {
                try {
                    resolve(OutQueryNotificationsHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    CouponTemplateServiceClient.prototype.getAnnotations = function (appID, couponTemplate) {
        var _this = this;
        var __data = new InGetAnnotations();
        __data.appID = appID;
        __data.couponTemplate = couponTemplate;
        return new Promise(function (resolve, reject) {
            _this._transport.send(CouponTemplateServiceClient.ClassName, 'getAnnotations', __data)
                .then(function (data) {
                try {
                    resolve(OutGetAnnotationsHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    CouponTemplateServiceClient.prototype.addAnnotation = function (appID, couponTemplate, text) {
        var _this = this;
        var __data = new InAddAnnotation();
        __data.appID = appID;
        __data.couponTemplate = couponTemplate;
        __data.text = text;
        return new Promise(function (resolve, reject) {
            _this._transport.send(CouponTemplateServiceClient.ClassName, 'addAnnotation', __data)
                .then(function (data) {
                try {
                    resolve(OutAddAnnotationHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    CouponTemplateServiceClient.PackageName = 'net.playq.octopus2.economy';
    CouponTemplateServiceClient.ClassName = 'CouponTemplateService';
    CouponTemplateServiceClient.FullClassName = 'net.playq.octopus2.economy.CouponTemplateService';
    return CouponTemplateServiceClient;
}());
exports.CouponTemplateServiceClient = CouponTemplateServiceClient;
var CouponTemplateServiceDispatcher = (function () {
    function CouponTemplateServiceDispatcher(marshaller, server) {
        this.marshaller = marshaller;
        this.server = server;
    }
    CouponTemplateServiceDispatcher.prototype.getSupportedService = function () {
        return 'CouponTemplateService';
    };
    CouponTemplateServiceDispatcher.prototype.getSupportedMethods = function () {
        return CouponTemplateServiceDispatcher.methods;
    };
    CouponTemplateServiceDispatcher.prototype.dispatch = function (context, method, data) {
        var _this = this;
        switch (method) {
            case "create": {
                var obj_1 = new InCreate(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.create(context, obj_1.app, obj_1.content)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutCreateHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "update": {
                var obj_2 = new InUpdate(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.update(context, obj_2.coupon)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutUpdateHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "delete": {
                var obj_3 = new InDelete(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.delete(context, obj_3.id)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutDeleteHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "promote": {
                var obj_4 = new InPromote(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.promote(context, obj_4.id, obj_4.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutPromoteHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "demote": {
                var obj_5 = new InDemote(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.demote(context, obj_5.id, obj_5.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutDemoteHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "get": {
                var obj_6 = new InGet(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.get(context, obj_6.id)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutGetHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "queryCoupons": {
                var obj_7 = new InQueryCoupons(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.queryCoupons(context, obj_7.app, obj_7.iterator, obj_7.sortBy, obj_7.filterBy)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutQueryCouponsHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "queryNotifications": {
                var obj_8 = new InQueryNotifications(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.queryNotifications(context, obj_8.appID, obj_8.couponTemplate, obj_8.iterator, obj_8.sortBy, obj_8.filterBy)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutQueryNotificationsHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "getAnnotations": {
                var obj_9 = new InGetAnnotations(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.getAnnotations(context, obj_9.appID, obj_9.couponTemplate)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutGetAnnotationsHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "addAnnotation": {
                var obj_10 = new InAddAnnotation(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.addAnnotation(context, obj_10.appID, obj_10.couponTemplate, obj_10.text)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutAddAnnotationHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            default:
                throw new Error("Method ".concat(method, " is not supported by CouponTemplateServiceDispatcher."));
        }
    };
    CouponTemplateServiceDispatcher.methods = [
        "create",
        "update",
        "delete",
        "promote",
        "demote",
        "get",
        "queryCoupons",
        "queryNotifications",
        "getAnnotations",
        "addAnnotation"
    ];
    return CouponTemplateServiceDispatcher;
}());
exports.CouponTemplateServiceDispatcher = CouponTemplateServiceDispatcher;
var CouponTemplateServiceServer = (function (_super) {
    __extends(CouponTemplateServiceServer, _super);
    function CouponTemplateServiceServer(marshaller) {
        var _this = _super.call(this, marshaller, null) || this;
        _this.server = _this;
        return _this;
    }
    CouponTemplateServiceServer.prototype.create = function (context, app, content) {
        throw new Error('Not implemented.');
    };
    CouponTemplateServiceServer.prototype.update = function (context, coupon) {
        throw new Error('Not implemented.');
    };
    CouponTemplateServiceServer.prototype.delete = function (context, id) {
        throw new Error('Not implemented.');
    };
    CouponTemplateServiceServer.prototype.promote = function (context, id, env) {
        throw new Error('Not implemented.');
    };
    CouponTemplateServiceServer.prototype.demote = function (context, id, env) {
        throw new Error('Not implemented.');
    };
    CouponTemplateServiceServer.prototype.get = function (context, id) {
        throw new Error('Not implemented.');
    };
    CouponTemplateServiceServer.prototype.queryCoupons = function (context, app, iterator, sortBy, filterBy) {
        throw new Error('Not implemented.');
    };
    CouponTemplateServiceServer.prototype.queryNotifications = function (context, appID, couponTemplate, iterator, sortBy, filterBy) {
        throw new Error('Not implemented.');
    };
    CouponTemplateServiceServer.prototype.getAnnotations = function (context, appID, couponTemplate) {
        throw new Error('Not implemented.');
    };
    CouponTemplateServiceServer.prototype.addAnnotation = function (context, appID, couponTemplate, text) {
        throw new Error('Not implemented.');
    };
    return CouponTemplateServiceServer;
}(CouponTemplateServiceDispatcher));
exports.CouponTemplateServiceServer = CouponTemplateServiceServer;
//# sourceMappingURL=CouponTemplateService.js.map